import React from 'react';
import { useSelector } from 'react-redux';
import { selectUserLoggedIn } from 'modules/login/slice/loginSlice';
import { saveCurrentPathForLoginRedirect } from 'services/loginRedirect';
import SessionActivityProvider from '../components/SessionActivityProvider';
import { ModalStackProvider } from 'components/ModalStack';

const PrivateRoute = ({ children }) => {
  const isLoggedIn = useSelector(selectUserLoggedIn);

  if (!isLoggedIn) {
    saveCurrentPathForLoginRedirect();
    // Redirect to login page using window.location.href to avoid React Router navigation issues
    window.location.href = '/login';
  }
  return (
    <SessionActivityProvider>
      <ModalStackProvider>{children}</ModalStackProvider>
    </SessionActivityProvider>
  );
};

export default PrivateRoute;
